export default {};
throw new Error(`Could not resolve "gsap/ScrollTrigger" imported by "@appletosolutions/reactbits". Is it installed?`)